import React, { useEffect, useState } from 'react';
import { useSearchBox } from '../../contexts/SearchBoxContext';
import { getSearchPlaceholder } from '../../tools/searchPlaceholder';
import { dynamicClassName } from '../../tools/tools';
import FloatingSearchBarInput from './FloatingSearchBarInput';

const pathToExclude = '/engine/';
const NAV_BAR_HEIGHT = 71;

interface FloatingSearchBarProps {
  placeholderSentences?: string[];
}

const FloatingSearchBar: React.FC<FloatingSearchBarProps> = ({ placeholderSentences }) => {
  const [isFocus, setIsFocus] = useState<boolean>(false);
  const [scrollY, setScrollY] = useState<number>(0);
  const [input, setInput] = useState<string>('');
  const [path, setPath] = useState<string>('');

  const { searchBoxPosition } = useSearchBox();
  const [isSearchBarVisible, setIsSearchBarVisible] = useState<boolean>(false);
  const placeholder = getSearchPlaceholder(placeholderSentences);

  const shouldDisplayBar = (path: string, scrollY: number, searchBoxPosition: number): void => {
    if (path === '' || path.includes(pathToExclude)) {
      setIsSearchBarVisible(false);
    } else {
      setIsSearchBarVisible(scrollY > searchBoxPosition - NAV_BAR_HEIGHT);
    }
  };

  const onInputChange = (e: string): void => setInput(e);

  useEffect(() => {
    setPath(window?.location?.pathname);
  }, []);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      setPath(window.location.pathname);
      const onScroll = () => {
        if (window.scrollY !== scrollY) {
          setScrollY(window.scrollY);
        }
        shouldDisplayBar(path, window.scrollY, searchBoxPosition.bottomPosition);
      };
      window.addEventListener('scroll', onScroll);
      return () => {
        window.removeEventListener('scroll', onScroll);
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [scrollY, searchBoxPosition.bottomPosition]);

  if (isSearchBarVisible) {
    return (
      <div className={dynamicClassName('floatingSearchBar-modal', isFocus)}>
        <FloatingSearchBarInput
          onInputChange={onInputChange}
          placeholder={placeholder}
          input={input}
          isFocus={isFocus}
          onFocus={setIsFocus}
        />
      </div>
    );
  }
  return null;
};

export default FloatingSearchBar;
